/* ============================================================
   Stelvio Restock Widget - logica JS (caricata GLOBALMENTE da
   layout/theme.liquid, mai inline nel snippet).
   PERCHE': il tema apre i prodotti via AJAX (product-drawer /
   navigazioni senza full reload) e gli <script> dentro HTML
   iniettato NON vengono eseguiti dal browser. Questo file vive
   nel contesto della pagina e un MutationObserver inizializza
   i widget man mano che entrano nel DOM.
   BUG CAMBIO TAGLIA (12 lug): al cambio variante il product.js
   del tema riscrive testo/stato di TUTTI i .single-add-to-cart-
   button, compreso il nostro (condivide le classi per lo stile).
   Difese: enforceLabel + observer sul root; bottoni del tema
   riconosciuti per appartenenza (non per classe .sold-out).
   ANTI-FLASH: la classe .sc-restock-on sul contenitore attiva
   una regola CSS (nel snippet) che nasconde all'ISTANTE i
   bottoni del tema e il checkout dinamico (Buy with Shop).
   TRANSIZIONI (2s): quando la variante torna disponibile
   anticipiamo il lavoro del tema (unstickThemeButtons) con le
   stringhe localizzate di window.theme.variantStrings.
   ⚠️ REGOLA VITALE - NIENTE BACKSLASH IN QUESTO FILE: viene
   caricato via GraphQL block string, che NON processa gli
   escape: una regex con backslash-s arriva nel file come
   DOPPIO backslash e cambia significato (bug del 13 lug: la
   validazione email rifiutava ogni indirizzo con la lettera
   's', bloccando il submit per tutti). Percio' email e parsing
   URL usano SOLO logica di stringa, mai regex.
   Il markup + CSS stanno in snippets/restock-notify.liquid.
   ============================================================ */
(function () {
  var API_URL = 'https://finance.stelviocollection.com/api/restock/subscribe';
  var API_TOKEN = '19c1cf7c236ec323537d763deb8e002d2e94532e0f21ad1414f4b8df81a9ab8f';

  var STR = {
    it: {
      button: 'Avvisami quando disponibile',
      title: 'Avvisami quando torna disponibile.',
      text: 'Riassortiamo spesso i prodotti più richiesti. Lascia i tuoi dati e ti avviseremo appena torna.',
      name: 'Il tuo nome',
      email: 'La tua email',
      submit: 'Invia richiesta',
      privacy: 'Rispettiamo la tua privacy: i tuoi dati restano riservati.',
      success: 'Fatto! Ti avviseremo appena torna disponibile.',
      already: 'Sei già iscritto per questa variante.',
      error: 'Si è verificato un errore. Riprova tra poco.'
    },
    en: {
      button: 'Notify me when available',
      title: 'Notify me when this item restocks.',
      text: 'We often restock popular items. Leave your details below and we will notify you as soon as it is back.',
      name: 'Enter name',
      email: 'Email address',
      submit: 'Submit request',
      privacy: 'We value your privacy and keep your details confidential.',
      success: 'Done! We will email you as soon as it is back in stock.',
      already: 'You are already subscribed for this variant.',
      error: 'Something went wrong. Please try again.'
    },
    de: {
      button: 'Benachrichtigen, wenn verfügbar',
      title: 'Benachrichtige mich, wenn es wieder da ist.',
      text: 'Beliebte Artikel füllen wir oft wieder auf. Hinterlasse deine Daten und wir informieren dich sofort.',
      name: 'Dein Name',
      email: 'Deine E-Mail',
      submit: 'Anfrage senden',
      privacy: 'Deine Daten bleiben vertraulich – versprochen.',
      success: 'Erledigt! Wir informieren dich, sobald es wieder verfügbar ist.',
      already: 'Du bist für diese Variante bereits angemeldet.',
      error: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.'
    }
  };

  // validazione email SENZA regex (vedi regola vitale in testa al file):
  // un solo simbolo chiocciola, niente spazi, un punto nel dominio con
  // almeno 2 caratteri dopo, e testo prima della chiocciola.
  function validEmail(s) {
    s = String(s || '').trim();
    if (s.length < 6 || s.indexOf(' ') !== -1) return false;
    var at = s.indexOf('@');
    if (at < 1 || s.indexOf('@', at + 1) !== -1) return false;
    var domain = s.slice(at + 1);
    var dot = domain.lastIndexOf('.');
    if (dot < 1) return false;
    var tld = domain.slice(dot + 1);
    if (tld.length < 2) return false;
    return true;
  }

  // id variante dall'URL SENZA regex
  function variantIdFromUrl() {
    var q = window.location.search || '';
    var idx = q.indexOf('variant=');
    if (idx === -1) return null;
    var vid = parseInt(q.slice(idx + 8), 10);
    return isNaN(vid) ? null : vid;
  }

  function initWidget(root) {
    if (root.dataset.scInit) return;
    root.dataset.scInit = '1';

    var dataEl = root.parentElement.querySelector('script.sc-restock-product') ||
                 root.nextElementSibling;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!product || !product.variants) return;

    var lang = (root.dataset.locale || 'en').slice(0, 2).toLowerCase();
    var t = STR[lang] || STR.en;

    function container() {
      return root.closest('.product, .product-information, section, main') || document;
    }
    function selectedVariant() {
      var scope = container();
      var input = scope.querySelector('form[action*="/cart/add"] [name="id"]') ||
                  document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (input && input.value) {
        var id = parseInt(input.value, 10);
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].id === id) return product.variants[i];
        }
      }
      var vid = variantIdFromUrl();
      if (vid) {
        for (var j = 0; j < product.variants.length; j++) {
          if (product.variants[j].id === vid) return product.variants[j];
        }
      }
      if (product.variants.length === 1) return product.variants[0];
      return null;
    }
    function themeButtons() {
      var all = container().querySelectorAll('.single-add-to-cart-button');
      var out = [];
      for (var i = 0; i < all.length; i++) {
        if (!all[i].closest('.sc-restock')) out.push(all[i]);
      }
      return out;
    }
    function enforceLabel() {
      var openBtn = root.querySelector('.sc-restock-open');
      if (!openBtn) return;
      var label = openBtn.querySelector('.sc-restock-open-label');
      if (!label) {
        openBtn.innerHTML = '<span class="single-add-to-cart-button--text sc-restock-open-label"></span>';
        label = openBtn.querySelector('.sc-restock-open-label');
      }
      if (label.textContent !== t.button) label.textContent = t.button;
      if (openBtn.disabled) openBtn.disabled = false;
      if (openBtn.classList.contains('sold-out')) openBtn.classList.remove('sold-out');
      if (openBtn.hasAttribute('aria-disabled')) openBtn.removeAttribute('aria-disabled');
    }
    enforceLabel();

    function unstickThemeButtons(btns) {
      var vs = (window.theme && window.theme.variantStrings) || {};
      for (var i = 0; i < btns.length; i++) {
        var b = btns[i];
        var txtEl = b.querySelector('.single-add-to-cart-button--text');
        if (!txtEl) continue;
        var txt = txtEl.textContent.trim();
        var stale = b.classList.contains('sold-out') || b.hasAttribute('disabled') ||
                    txt === 'Sold out' || (vs.soldOut && txt === vs.soldOut);
        if (!stale) continue;
        if (b.classList.contains('sold-out')) b.classList.remove('sold-out');
        if (b.hasAttribute('disabled')) b.removeAttribute('disabled');
        if (vs.addToCart && txtEl.textContent !== vs.addToCart) txtEl.textContent = vs.addToCart;
      }
    }

    var iv = null;
    var lastScope = null;
    function refresh() {
      if (!document.body.contains(root)) {
        if (iv) clearInterval(iv);
        if (lastScope && lastScope.classList && lastScope.classList.contains('sc-restock-on')) {
          lastScope.classList.remove('sc-restock-on');
        }
        return;
      }
      var v = selectedVariant();
      var show = !!(v && !v.available);
      enforceLabel();
      var want = show ? 'block' : 'none';
      if (root.style.display !== want) root.style.display = want;
      var scope = container();
      lastScope = scope;
      if (scope && scope !== document && scope.classList &&
          scope.classList.contains('sc-restock-on') !== show) {
        scope.classList.toggle('sc-restock-on', show);
      }
      var btns = themeButtons();
      for (var i = 0; i < btns.length; i++) {
        if (show) {
          if (btns[i].style.display !== 'none') { btns[i].style.display = 'none'; btns[i].dataset.scHidden = '1'; }
        } else if (btns[i].dataset.scHidden === '1') {
          btns[i].style.display = '';
          delete btns[i].dataset.scHidden;
        }
      }
      if (!show) unstickThemeButtons(btns);
    }
    document.addEventListener('change', refresh, true);
    window.addEventListener('popstate', refresh);
    iv = setInterval(refresh, 600);
    refresh();

    var rafPending = false;
    function scheduleRefresh() {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () { rafPending = false; refresh(); });
    }
    var scopeEl = container();
    if (scopeEl && scopeEl !== document) {
      new MutationObserver(scheduleRefresh)
        .observe(scopeEl, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'class', 'style', 'disabled'] });
    }

    new MutationObserver(function () { enforceLabel(); })
      .observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class', 'aria-disabled'] });

    function ensureModal() {
      var ov = document.getElementById('sc-restock-overlay');
      if (ov) return ov;
      ov = document.createElement('div');
      ov.id = 'sc-restock-overlay';
      ov.className = 'sc-restock-overlay';
      ov.hidden = true;
      ov.innerHTML =
        '<div class="sc-restock-modal" role="dialog" aria-modal="true">' +
          '<button type="button" class="sc-restock-close" aria-label="Close">&times;</button>' +
          '<img class="sc-restock-img" src="" alt="">' +
          '<h3 class="sc-restock-title"></h3>' +
          '<p class="sc-restock-text"></p>' +
          '<p class="sc-restock-prod"></p>' +
          '<div class="sc-restock-form">' +
            '<div class="sc-restock-opts"></div>' +
            '<input type="text" class="sc-restock-input sc-restock-name" autocomplete="name">' +
            '<input type="email" class="sc-restock-input sc-restock-email" autocomplete="email" inputmode="email">' +
            '<input type="text" class="sc-restock-hp" name="website" tabindex="-1" autocomplete="off" style="position:absolute;left:-9999px;height:0;width:0;opacity:0;">' +
            '<button type="button" class="single-add-to-cart-button button accent sc-restock-submit"><span class="single-add-to-cart-button--text"></span></button>' +
            '<p class="sc-restock-error" hidden></p>' +
          '</div>' +
          '<div class="sc-restock-success" hidden>' +
            '<svg viewBox="0 0 24 24" width="36" height="36" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><path d="M8 12.5l2.5 2.5L16 9.5"></path></svg>' +
            '<p></p>' +
          '</div>' +
          '<p class="sc-restock-privacy"></p>' +
        '</div>';
      document.body.appendChild(ov);
      ov.addEventListener('click', function (e) { if (e.target === ov) ov.hidden = true; });
      ov.querySelector('.sc-restock-close').addEventListener('click', function () { ov.hidden = true; });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ov.hidden) ov.hidden = true; });
      return ov;
    }

    function imgUrl(x) {
      if (!x) return '';
      if (typeof x === 'object') x = x.src || '';
      if (typeof x !== 'string') return '';
      if (x.indexOf('//') === 0) return 'https:' + x;
      return x;
    }
    function variantImg(vv) {
      return imgUrl(vv && vv.featured_image) || imgUrl(product.featured_image) ||
             imgUrl(product.images && product.images[0]) || '';
    }
    function optionValues(idx) {
      var seen = [], i, val;
      for (i = 0; i < product.variants.length; i++) {
        val = product.variants[i]['option' + idx];
        if (val && seen.indexOf(val) === -1) seen.push(val);
      }
      return seen;
    }
    function variantByOptions(sel) {
      for (var i = 0; i < product.variants.length; i++) {
        var vv = product.variants[i], ok = true;
        for (var k = 0; k < 3; k++) {
          if (sel[k] != null && vv['option' + (k + 1)] !== sel[k]) ok = false;
        }
        if (ok) return vv;
      }
      return null;
    }

    root.querySelector('.sc-restock-open').addEventListener('click', function () {
      var v = selectedVariant();
      if (!v) return;
      var ov = ensureModal();
      var q = function (sel) { return ov.querySelector(sel); };

      var cur = v;

      function updateModal() {
        var img = variantImg(cur);
        q('.sc-restock-img').src = img;
        q('.sc-restock-img').style.display = img ? 'block' : 'none';
        q('.sc-restock-prod').textContent = product.title +
          (cur && cur.title && cur.title !== 'Default Title' ? ' — ' + cur.title : '');
        q('.sc-restock-submit').disabled = !cur;
      }

      var optsBox = q('.sc-restock-opts');
      optsBox.innerHTML = '';
      var selects = [null, null, null];
      var names = product.options || [];
      for (var oi = 0; oi < Math.min(names.length, 3); oi++) {
        if (!names[oi] || names[oi] === 'Title') continue;
        var values = optionValues(oi + 1);
        if (!values.length) continue;
        var label = document.createElement('label');
        label.appendChild(document.createTextNode(names[oi]));
        var sel = document.createElement('select');
        sel.className = 'sc-restock-select';
        for (var vi = 0; vi < values.length; vi++) {
          var op = document.createElement('option');
          op.value = values[vi];
          op.textContent = values[vi];
          sel.appendChild(op);
        }
        sel.value = v['option' + (oi + 1)] || values[0];
        sel.addEventListener('change', function () {
          var chosen = [
            selects[0] ? selects[0].value : null,
            selects[1] ? selects[1].value : null,
            selects[2] ? selects[2].value : null
          ];
          cur = variantByOptions(chosen);
          updateModal();
        });
        selects[oi] = sel;
        label.appendChild(sel);
        optsBox.appendChild(label);
      }

      q('.sc-restock-img').onerror = function () { this.style.display = 'none'; };
      q('.sc-restock-title').textContent = t.title;
      q('.sc-restock-text').textContent = t.text;
      updateModal();
      q('.sc-restock-name').placeholder = t.name;
      q('.sc-restock-email').placeholder = t.email;
      q('.sc-restock-submit .single-add-to-cart-button--text').textContent = t.submit;
      q('.sc-restock-privacy').textContent = t.privacy;
      q('.sc-restock-error').hidden = true;
      q('.sc-restock-form').style.display = '';
      q('.sc-restock-success').hidden = true;
      q('.sc-restock-email').classList.remove('sc-invalid');
      ov.hidden = false;
      setTimeout(function () { q('.sc-restock-email').focus(); }, 60);

      q('.sc-restock-submit').onclick = function () {
        if (!cur) return;
        var email = (q('.sc-restock-email').value || '').trim();
        if (!validEmail(email)) {
          q('.sc-restock-email').classList.add('sc-invalid');
          q('.sc-restock-email').focus();
          return;
        }
        q('.sc-restock-email').classList.remove('sc-invalid');
        q('.sc-restock-error').hidden = true;
        var btn = q('.sc-restock-submit');
        btn.disabled = true;

        var payload = {
          type: 'restock',
          email: email,
          name: (q('.sc-restock-name').value || '').trim() || null,
          website: q('.sc-restock-hp').value || '',
          productId: product.id,
          productTitle: product.title,
          productHandle: product.handle,
          variantId: cur.id,
          variantTitle: cur.title,
          sku: cur.sku || null,
          option1: cur.option1 || null,
          option2: cur.option2 || null,
          price: cur.price != null ? cur.price : null,
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || null,
          locale: lang,
          shop: window.location.hostname
        };

        fetch(API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'x-restock-token': API_TOKEN },
          body: JSON.stringify(payload)
        })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (b) { return { ok: res.ok, body: b }; });
        })
        .then(function (r) {
          btn.disabled = false;
          if (r.ok) {
            q('.sc-restock-success p').textContent = (r.body && r.body.duplicate) ? t.already : t.success;
            q('.sc-restock-form').style.display = 'none';
            q('.sc-restock-success').hidden = false;
          } else {
            q('.sc-restock-error').textContent = t.error;
            q('.sc-restock-error').hidden = false;
          }
        })
        .catch(function () {
          btn.disabled = false;
          q('.sc-restock-error').textContent = t.error;
          q('.sc-restock-error').hidden = false;
        });
      };

      q('.sc-restock-email').onkeydown = function (e) { if (e.key === 'Enter') q('.sc-restock-submit').click(); };
    });
  }

  function boot() {
    var roots = document.querySelectorAll('.sc-restock');
    for (var i = 0; i < roots.length; i++) initWidget(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // ===== AJAX-proof =====
  var bootScheduled = false;
  function scheduleBoot() {
    if (bootScheduled) return;
    bootScheduled = true;
    setTimeout(function () { bootScheduled = false; boot(); }, 120);
  }
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes && muts[i].addedNodes.length) { scheduleBoot(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scheduleBoot);
  window.addEventListener('pageshow', scheduleBoot);
})();